import React from 'react';
import { Divider } from 'antd';

const SbDivider = (props) => {
    return <Divider {...props} />;
};

export default SbDivider;
